import { usePalette, WHITE_THEME } from "@/lib/theme";

// tone "light" = light lettering for dark backgrounds, "dark" = for light backgrounds.
// Each palette has its own recolour of the same drawing: logo-emma-sage*.png, logo-emma-panna*.png.
export const Logo = ({ tone = "light", className = "h-10" }) => {
  const palette = usePalette();
  const sfx = WHITE_THEME && palette !== "white" ? `-${palette}` : "";
  return (
    <img
      src={`/img/logo-emma${sfx}${tone === "light" ? "-light" : ""}.png`}
      alt="Emma Industrie — Timber Industry 1905"
      className={`block w-auto select-none ${className}`}
      draggable="false"
      data-testid={`site-logo-${tone}`}
    />
  );
};
